import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 px-4 bg-dark-800 relative" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <FadeIn data-id="element-110">
          <div className="relative" data-id="element-111">
            {/* Decorative quotes */}
            <span className="absolute -top-10 -left-6 text-6xl font-serif text-gold/20 select-none" data-id="element-112">
              "
            </span>

            <p className="text-xl md:text-2xl leading-relaxed font-serif italic text-offwhite/90 text-center" data-id="element-113">
              Estás en ese momento. Son las 3 de la mañana y tu mente no para.
              Repasas cada conversación, cada grito y cada mirada fría,
              intentando entender en qué momento "fallaste" para que todo se
              volviera un infierno.
            </p>

            <div className="w-12 h-[1px] bg-gold/30 mx-auto my-8" data-id="element-114" />

            <p className="text-lg md:text-xl leading-relaxed text-offwhite/80 text-center font-light" data-id="element-115">
              Sientes un vacío en el pecho que no se llena con nada y un
              cansancio que el sueño no cura. No es solo tristeza. Es la
              sensación aterradora de que la mujer fuerte y segura que solías
              ser ha desaparecido, reemplazada por alguien que camina sobre
              cáscaras de huevo para no desatar el caos.
            </p>

            <span className="absolute -bottom-10 -right-6 text-6xl font-serif text-gold/20 select-none rotate-180" data-id="element-116">
              "
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}